

export default {
  props: [
    'error',
  ],
};
